<template>
  <!-- GSMA -->
  <div class="tips-wrap">
    <el-checkbox
      v-track="{
        type: 'click',
        name: `${$route.params.type || 'phone'}.${
          $route.params.step || 'account'
        }.agreement`,
      }"
      class="checkbox-custom"
      v-bind="$attrs"
      v-on="$listeners"
    />
    <div class="tips-text">
      <span>{{ $t('login.register.gsmaAgreeReadPreText') }}</span>
      <a
        class="a-custom"
        :href="getLang('privacy')"
        target="_blank"
        v-track="{ type: 'click', name: `form.privacy_details` }"
      >
        {{ $t('login.register.gsmaAgreeReadPreText3') }}
      </a>
      <!-- <span>{{ $t('login.register.gsmaAgreeReadPreText2') }}</span> -->
    </div>
  </div>
</template>
<script>
import { getLang } from '@/utils/storage.js'
import { getBusinessType } from '@/constant'

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
      gsmaConfig: {
        // 用户协议：
        // termsen: '/term&agreement/gsma/terms.html',
        // termscn: '/term&agreement/gsma/terms.html',
        termsen: 'https://www.gotin.online/cn/terms/',
        termscn: 'https://www.gotin.online/cn/terms/',

        // 隐私条款：
        // privacyen: '/term&agreement/gsma/privacy.html',
        // privacycn: '/term&agreement/gsma/privacy.html',
        privacyen: 'https://www.mwcbarcelona.com/privacy-notice/attendees',
        privacycn: 'https://www.mwcbarcelona.com/privacy-notice/attendees-cn',
      },
    }
  },
  computed: {
    singleStatus() {
      return getBusinessType().hasOwnThemeStyle
    },
    configStyle() {
      return getBusinessType().className
    },
    agreeReadPreText() {
      return getBusinessType().agreeReadPreText
    },
    agreeAnd() {
      return getBusinessType().agreeAnd
    },
  },
  methods: {
    getLang(param) {
      return this.gsmaConfig[param + getLang().toString()]
    },
  },
}
</script>
<style lang="scss" scoped>
.tips-wrap {
  display: flex;
  margin-bottom: 12px;
  margin-top: 28px;
}

.checkbox-custom {
  height: 22px;
  margin-right: 12px;
}

.tips-text {
  color: #5c5c5c;
  font-size: 14px;
  line-height: 22px;
}
</style>
<style lang="scss">
.nissan-wrap.el-checkbox {
  margin-right: 6px;

  .el-checkbox__inner {
    border-radius: 0;
    background-color: rgba(0, 0, 0, 0.3);
    border-color: transparent;
    width: 24px;
    height: 24px;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: rgba(0, 0, 0, 0.3);
    border-color: transparent;
  }
}

.tips-text.nissan-wrap {
  font-size: 12px;
  color: #fff;

  .a-custom {
    color: #ff99f4;
  }
}
</style>
